/* tslint:disable */

declare var Object: any;
export interface AccessmanagementInterface {
  "id"?: number;
}

export class Accessmanagement implements AccessmanagementInterface {
  "id": number;
  constructor(data?: AccessmanagementInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Accessmanagement`.
   */
  public static getModelName() {
    return "Accessmanagement";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Accessmanagement for dynamic purposes.
  **/
  public static factory(data: AccessmanagementInterface): Accessmanagement{
    return new Accessmanagement(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Accessmanagement',
      plural: 'Accessmanagements',
      path: 'Accessmanagements',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Accessmanagement.ts